import React from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import { Form } from 'antd';
import BalanceCard from '../../../../../components/ui/BalanceCard/BalanceCard';
import OneFieldFormModal from '../../../../../components/ui/modals/OneFieldFormModal/OneFieldFormModal';
import useChangeModalVisible from '../../../../../../../hooks/useChangeModalVisible';
import useHouseBalance from '../../../../../queries/useHouseBalance';
import changeHouseBalance from '../../../../../requests/changeHouseBalance';
import { texts } from '../../../../../constants/texts';

const ChangeBalanceModal = Form.create({ name: 'change_house_balance' })(
  OneFieldFormModal
);

const HouseBalance = ({ address }) => {
  const { visible, showModal, hideModal } = useChangeModalVisible();

  const params = useParams();

  const queryClient = useQueryClient();

  const houseId = Number(params.pageId);

  const { data: houseBalance, isFetching: isHouseBalanceFetching } =
    useHouseBalance(houseId, { staleTime: Infinity });

  const handleSubmit = async (fieldsValues) => {
    const replaceBalance = fieldsValues.balance.replace(/,/g, '.');
    const fixedBalance = (replaceBalance * 100).toFixed();
    const balance = Number(fixedBalance);
    const values = { balance };

    const res = await changeHouseBalance(houseId, values);

    if (res.result === 'Ok') {
      queryClient.invalidateQueries([`houseBalance`, houseId]);
    }
  };

  return (
    <>
      <BalanceCard
        onChangeButtonClick={showModal}
        balance={houseBalance?.balance}
        loading={isHouseBalanceFetching}
        title={texts.homeBalance}
      />
      <ChangeBalanceModal
        visible={visible}
        onCancel={hideModal}
        initialValue={(houseBalance?.balance / 100).toFixed(2)}
        subtitle={address}
        title={texts.rebalancing}
        okText={texts.edit}
        cancelText={texts.cancel}
        label={texts.balance}
        inputName="balance"
        onSubmit={handleSubmit}
        validationTypes={['fractional']}
        requiredErrMsg="Укажите баланс"
        numberComparison
      />
    </>
  );
};

export default HouseBalance;
